import React, {Component} from 'react'
import {FormGroup, Input, Badge, Label} from 'reactstrap'

import ProjectSearch from '../timesheet/Search'

export default class ProjectBudgetSelection extends Component{

    state = {
        project: null
    }


    render(){

        const {selectedBudgetId} = this.props
        const project = (this.state.project) ? this.state.project : this.props.project

        return (
            <div>
                <ProjectSearch selectedProject={project} onSearch={(search) => console.log(search)} onChange={(data) => this.setState({project: data[0]})}/>

                {(project && project.project_activity_budgets) &&
                project.project_activity_budgets.map(({id, description, breakdown, project_activity_type, project_activity_type_id, address, stage}, index) => {
                    return (
                        <FormGroup check key={index}>
                            <Label check style={{display: 'block'}}>
                                <Input
                                    onChange={(evt) => {
                                        this.props.onChange(evt.target.value)
                                    }}
                                    type="radio"
                                    value={id}
                                    name="activities"
                                    checked={selectedBudgetId && selectedBudgetId === id}
                                />
                                {(stage) && `Stage: ${stage} - `}{project_activity_type.description} {(description) && ` - ${description}`}
                                {(address) && <h6><Badge color="primary">{address.full_address}</Badge></h6>}
                            </Label>
                        </FormGroup>
                    )
                })}
            </div>

        )
    }

}